// extracted by mini-css-extract-plugin
export default {"inputWrapper":"e0vsk","input":"ZWCUM"};